import { useEffect, useState } from "react"
import { useCategoriesStore } from "../stores/categoriesStore"
import { useSearchStore } from "../stores/searchStore"
import { useTranslation } from "react-i18next"
import { useNavigate, useLocation } from "react-router-dom"

const DEFAULT_VALUE = 'all'

const SearchProducts = ({
    style = 'style-one', 
    className = '', 
    onSubmitSuccess,
    visibleBreakpoints = 'd-block', // Default to always visible
    width = '' // Width control prop - can be any CSS width class like 'w-100', 'w-300', etc.
}) => {
    const {categories, loading} = useCategoriesStore((state) => state)
    const {
        searchText,
        selectedCategory,
        setSearchText,
        setSelectedCategory
    } = useSearchStore((state) => state)
    
    const [text, setText] = useState('')
    const {t} = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    // Update search store from URL when component mounts
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        if (location.pathname === '/shop') {
            useSearchStore.getState().updateFromUrl(searchParams)
        }
    }, [location])

    useEffect(() => {
        setText(searchText)
    }, [searchText])

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault()

        setSearchText(text)
        
        const searchParams = useSearchStore.getState().getSearchParams()
        navigate(`/shop?${searchParams.toString()}`)
        
        // Call the success callback if provided
        if (onSubmitSuccess) {
            onSubmitSuccess()
        }
    }

    // Handle category change
    const handleCategoryChange = (e) => {
        setSelectedCategory(e.target.value)
    }

    // Handle search input change
    const handleSearchChange = (e) => {
        setText(e.target.value)
    }

    return (
        <div className={`${visibleBreakpoints} ${width}`}>
        {
            style == 'style-two' ? (
            <form
                onSubmit={handleSubmit}
                className={`flex-wrap flex-align form-location-wrapper ${className}`}
              >
                <div className='h-48 search-category style-two d-flex search-form d-sm-flex tw-w-full'>
                  {/* <select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    className='border border-0 border-gray-200 js-example-basic-single border-end-0 rounded-0'
                    name='state'
                  >
                    <option value={DEFAULT_VALUE}>{t('categories.all')}</option>
                    {
                        categories && categories.map(c => {
                            return (
                                <option key={c.slug} value={c.slug}>{c.name}</option>
                            )
                        })
                    }
                  </select> */}
                  <div className='position-relative tw-w-full'>
                    <input
                        type='text'
                        value={text}
                        onChange={handleSearchChange}
                        className='border-0 search-form__input !tw-w-full common-input py-13 ps-16 pe-18 rounded-0'
                        placeholder={t('categories.searchMessage')}
                    />
                  </div>
                  <button
                    type='submit'
                    className='flex-shrink-0 w-48 text-xl text-white bg-main-two-600 flex-center hover-bg-main-two-700 d-lg-flex'
                  >
                    <i className='ph ph-magnifying-glass' />
                  </button>
                </div>
              </form>
            ) : (
            <form
                onSubmit={handleSubmit}
                className={`flex-wrap flex-align form-location-wrapper ${className}`}
            >
                <div className='h-48 search-category d-flex select-border-end-0 radius-end-0 search-form d-sm-flex d-block'>
                    {/* <select
                        value={selectedCategory}
                        onChange={handleCategoryChange}
                        className={`border border-0 border-gray-200 js-example-basic-single border-end-0`}
                        name='state'
                    >
                        <option value={DEFAULT_VALUE}>{t('categories.all')}</option>
                        {
                            categories && categories.map(c => {
                                return (
                                    <option key={c.slug} value={c.slug}>{c.name}</option>
                                )
                            })
                        }
                    </select> */}
                    <div className='search-form__wrapper position-relative w-100'>
                        <input
                            type='text'
                            value={text}
                            onChange={handleSearchChange}
                            className={`search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44 w-100`}
                            placeholder={t('categories.searchMessage')}
                        />
                        <button
                            type='submit'
                            className='w-32 h-32 text-xl text-white bg-main-600 rounded-circle flex-center position-absolute top-50 translate-middle-y inset-inline-end-0 me-8'
                        >
                            <i className='ph ph-magnifying-glass' />
                        </button>
                    </div>
                </div>
            </form>
            )
        }
        </div>
    )
}

export default SearchProducts